import React from "react";
import { Tooltip } from "react-tippy";
import { isMobile } from "helpers/Mobile";

import styles from "./UserTableItem.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const tooltipStyle = {
  background: "#FFFFFF",
  boxShadow: "0px 3px 6px #00000029",
  height: "45px",
  padding: "0 15px",
  color: "#494F66",
  fontFamily: "Roboto-Light",
  fontSize: "18px",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center",
};

const statusMap = {
  INT: capitalize(i18n.t("integrated")),
  NOT: capitalize(i18n.t("not.integrated")),
  PEN: capitalize(i18n.t("pending.integration")),
  ACT: capitalize(i18n.t("active")),
  INA: capitalize(i18n.t("inactive")),
};

const UserTableItem = ({ user, handleClick }) => {
  // const columns = ["image", "name", "email", "role", "status"];
  const columns = ["name", "email", "role", "status"];


  const renderPill = (status) => {
    return (
      <div className={styles["user-table-pill-container"]}>
        <div className={styles["user-table-pill"] + ' ' + styles[status ? `user-table-pill-${status.toLowerCase()}` : ""]}>
          <p>{statusMap[status]}</p>
        </div>
      </div>
    );
  };

  const renderColumn = (key) => {
    return (
      <div
        className={styles[`user-table-item-${key}`] + ' ' + styles['user-table-item']}
        data-user-id={key}
        onClick={() => handleClick(user.id)}
        key={key}
      >
        <Tooltip
          html={
            <div style={tooltipStyle}>
              {key === "status" ? statusMap[user[key]] : user[key]}
            </div>
          }
          followCursor={true}
          position="left"
          offset={25}
          disabled={["image"].includes(key)}
        >
          {key === "image" && user.image && <img src={user.image} />}
          {key === "status" && <>{renderPill(user[key])}</>}
          {!["image", "status"].includes(key) && <p>{user[key]}</p>}

        </Tooltip>
      </div>
    );
  };

  return (
    <div
      className={styles["user-table-item-wrapper"]}
      data-automation-id="user-item-wrapper"
    >
      {!isMobile && (
        <div className={styles["user-table-item-container"]} data-automation-id="user-item">
          {columns.map((column_key) => {
            return renderColumn(column_key);
          })}
          <div
            className={styles["user-table-item-button"] + ' ' + styles["user-table-item"]}
            data-automation-id="user-button"
            data-user-id={user.id}
            onClick={() => handleClick(user.id)}
            key={"button-2"}
          >
            <i className="icon-chevron"></i>
          </div>
        </div>
      )}
      {isMobile && (
        <div className={styles["user-table-item-container-mobile"]}  onClick={() => handleClick(user.id)} >
           <div className={styles["user-table-item-column-mobile"]}>
            <div className={styles["user-image"]}>
              <img src={user.image} />
            </div>
          </div>
          <div className={styles["user-table-item-column-mobile"]}>

            <div className={styles["user-table-item-row-mobile"]}>
              <p className={styles["header"]}>{user.name}</p>
            </div>

            <div className={styles["user-table-item-row-mobile"]}>
              <p className={styles["body"]}>{i18n.t("email")}: <span>{user.email}</span></p>
            </div>
            <div className={styles["user-table-item-row-mobile"]}>
              <p className={styles["body"]}>Rol: <span>{user.role}</span></p>
            </div>

          </div>

          <div className={styles["user-table-item-column-mobile"]}>
            <div className={styles["user-pill-mobile-container"]}>
              {renderPill(user.status)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserTableItem;
